import {
  faFacebook,
  faTiktok,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";

export default function BakeryFooter() {
  return (
    <footer className=" text-center text-neutral-600 bg-gray-800 dark:bg-gray-800 dark:text-neutral-200 lg:text-left">
      <div className="flex items-center justify-center border-b-2  p-6 dark:border-neutral-500 lg:justify-between">
        <div className="mr-12 hidden lg:block">
          <span>Get connected with us on social networks:</span>
        </div>
        {/* <!-- Social network icons container --> */}
        <div className="flex justify-center">
          <p className="mr-6 text-neutral-600 dark:text-neutral-200">
            <Link
              to="https://www.facebook.com/profile.php?id=100063539946121"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faFacebook} size="lg" />
            </Link>
          </p>
          <p className="mr-6 text-neutral-600 dark:text-neutral-200">
            <Link
              to="https://www.facebook.com/profile.php?id=100063539946121"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faWhatsapp} size="lg" />
            </Link>
          </p>
          <p className="mr-6 text-neutral-600 dark:text-neutral-200">
            <Link
              to="https://www.tiktok.com/@sauraha.gourmet.bakery/video/7251574436875291906?_d=secCgYIASAHKAESPgo8v%2FScHsgOt09Tq1Y7F4eXqZHPwConosHPQNCLmVlLxbpkrvVszdJ4fz8xNMg3h9dU67NteVMlkf7GCcI4GgA%3D&_r=1&checksum=5de06944543d08427d85c465e93e1357ca10a9fc20ca788409349dea6fdebaf3&preview_pb=0&sec_user_id=MS4wLjABAAAAM2-oH47bvSUYiyWpSerJ9Y6OtLidwTm_HsfK-z9ZbcMy4qiHOBwaFOrO9pHiSAPW&share_app_id=1233&share_item_id=7251574436875291906&share_link_id=115897f5-66dd-44c5-bee8-f4722fe842f8&sharer_language=en&social_share_type=0&source=h5_m&timestamp=1688388755&u_code=e6i7l48a88351j&ug_btm=b2001&ugbiz_name=Main&user_id=7205475541146174490&utm_campaign=client_share&utm_medium=android&utm_source=facebook&fbclid=IwAR3I5BTgPer32k-dozmANhnAZGJhm9Ob2n_GGTqcN1WuL6GQU0lnWJ_8Ij4"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faTiktok} size="lg" />
            </Link>
          </p>
        </div>
      </div>

      {/* <!-- Main container div: holds the entire content of the footer, including four sections (TW Elements, Products, Useful links, and Contact), with responsive styling and appropriate padding/margins. --> */}
      <div className="mx-6 py-10 text-center md:text-left">
        <div className="grid-1 grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* <!-- TW Elements section --> */}
          <div className="">
            <h6 className="mb-4 flex items-center justify-center font-semibold uppercase md:justify-start">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="mr-3 h-4 w-4"
              >
                <path d="M12.378 1.602a.75.75 0 00-.756 0L3 6.632l9 5.25 9-5.25-8.622-5.03zM21.75 7.93l-9 5.25v9l8.628-5.032a.75.75 0 00.372-.648V7.93zM11.25 22.18v-9l-9-5.25v8.57a.75.75 0 00.372.648l8.628 5.033z" />
              </svg>
              Sauraha Gourmet
            </h6>
            <p>
              Indulge in our mouth-watering cakes made with love and passion.
            </p>
          </div>
          {/* <!-- Products section --> */}
          <div className="">
            <h6 className="mb-4 flex justify-center font-semibold uppercase md:justify-start">
              Products
            </h6>
            <p className="mb-4">
              <p className="text-neutral-600 dark:text-neutral-200">Cakes</p>
            </p>
            <p className="mb-4">
              <p className="text-neutral-600 dark:text-neutral-200">
                Chocolate
              </p>
            </p>
            <p className="mb-4">
              <p className="text-neutral-600 dark:text-neutral-200">Pastry</p>
            </p>
            <p>
              <p className="text-neutral-600 dark:text-neutral-200">Bakery </p>
            </p>
          </div>
          {/* <!-- Useful links section --> */}
          <div className="">
            <h6 className="mb-4 flex justify-center font-semibold uppercase md:justify-start">
              Useful links
            </h6>
            <p className="mb-4">
              <p className="text-neutral-600 dark:text-neutral-200">Pricing</p>
            </p>
            <p className="mb-4">
              <p className="text-neutral-600 dark:text-neutral-200">Settings</p>
            </p>
            <p className="mb-4">
              <p className="text-neutral-600 dark:text-neutral-200">Orders</p>
            </p>
            <p>
              <p className="text-neutral-600 dark:text-neutral-200">Help</p>
            </p>
          </div>
          {/* <!-- Contact section --> */}
          <div>
            <h6 className="mb-4 flex justify-center font-semibold uppercase md:justify-start">
              Contact
            </h6>
            <p className="mb-4 flex items-center justify-center md:justify-start">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="mr-3 h-5 w-5"
              >
                <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z" />
                <path d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z" />
              </svg>
              Chitwan, Sauraha Chara Chowk
            </p>
            <p className="mb-4 flex items-center justify-center md:justify-start">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="mr-3 h-5 w-5"
              >
                <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
              </svg>
              info@example.com
            </p>
            <p className="mb-4 flex items-center justify-center md:justify-start">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="mr-3 h-5 w-5"
              >
                <path
                  fillRule="evenodd"
                  d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z"
                  clipRule="evenodd"
                />
              </svg>
              +977 984-5173326 

            </p>
          </div>
        </div>
      </div>

      {/* <!--Copyright section--> */}
      <div className="bg-gray-800 p-6 text-center ">
        <span>© 2023 Copyright:</span>
        <a
          className="font-semibold text-neutral-600 dark:text-neutral-400"
          href="https://tw-elements.com/"
        >
          Sauraha Bakery
        </a>
      </div>
    </footer>
  );
}
